<template>
  <div class="student" v-loading="loading">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="姓名" align="center" width="100">
        <template slot-scope="scope">{{ scope.row.user_name }}</template>
      </el-table-column>
      <el-table-column label="部门" align="center" width="100">
        <span slot-scope="scope" v-if="scope.row.class_">{{
          scope.row.class_.sys_class_name
        }}</span>
        <span v-else>无</span>
      </el-table-column>
      <el-table-column label="得分" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.score }}</template>
      </el-table-column>
      <el-table-column label="选项">
        <template slot-scope="scope">
          <span v-for="(item, index) in scope.row.option" :key="index">
            p{{ item.p }}:{{ item.select }}；
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'Export',
  data() {
    return {
      tableData: [],
      data: [],
      total: 0,
      page: 1,
      loading: true,
      code: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
    }
  },
  created() {
    let _this = this
    _this.getListData()
  },
  methods: {
    async getListData() {
      let _this = this,
        content = []
      let results = await _this.getData(1)
      content = content.concat(results.data)

      let total = results.total
      let page = Math.ceil(total / 100)
      let cur_page = 1

      if (page > 1) {
        for (var i = 2; i <= page; i++) {
          cur_page = i
          let newResults = await _this.getData(i)
          content = content.concat(newResults.data)
        }
      }
      _this.data = content
      if (cur_page == page) {
        _this.getList()
      }
    },
    async getList() {
      let _this = this
      for (let i = 0; i < _this.data.length; i++) {
        _this.data[i].option = await _this.getInfo(_this.data[i].id)
      }

      _this.tableData = _this.data
      console.log(_this.tableData)
      _this.loading = false
    },
    async getData(page) {
      return new Promise((resolve, reject) => {
        let _this = this
        _this.$http
          .post(process.env.VUE_APP_URL + 'results', {
            id: _this.$route.params.id,
            page: page,
          })
          .then(function(data) {
            if (data.data.code == 200) {
              resolve(data.data)
            }
          })
          .catch(function(error) {
            console.log(error)
            _this.$message.error('网络错误,请刷新界面重试')
            return
          })
      })
    },
    async getInfo(id) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          let _this = this
          _this.$http
            .get(process.env.VUE_APP_URL + 'results/resultQuestionInfo/' + id)
            .then(function(data) {
              if (data.data.code == 200) {
                let array = []
                data.data.data.question.forEach((ele, i) => {
                  if (ele.question.type == 1) {
                    //单选
                    let obj = ele.option.find((e, index) => {
                      e.index = index
                      return e.id == ele.seleted
                    })
                    if (obj) {
                      ele.select = _this.code[obj.index]
                    }
                  }
                  if (ele.question.type == 2) {
                    //多选
                    let arr_1 = ele.seleted.split(',')
                    let select_arr = []
                    arr_1.forEach(v => {
                      let obj = ele.option.find((e, index) => {
                        e.index = index
                        return e.id == v
                      })
                      if (obj) {
                        select_arr.push(_this.code[obj.index])
                        ele.select = select_arr.toString()
                      }
                    })
                  }
                  if (ele.question.type == 3) {
                    //判断
                    let obj = ele.option.find(e => {
                      return e.id == ele.seleted
                    })
                    if (obj) {
                      ele.select = obj.name
                    }
                  }
                  if (ele.question.type == 4) {
                    //填空
                    ele.select = ele.seleted
                  }
                  array.push({
                    p: i + 1,
                    select: ele.select ? ele.select : '',
                  })
                })
                resolve(array)
              }
            })
            .catch(function(error) {
              console.log(error)

              _this.$message.error('网络错误,请刷新界面重试')
              return
            })
        }, 1000)
      })
    },
  },
}
</script>

<style lang="less">
.el-table th {
  user-select: initial !important;
}
</style>
